import { render, staticRenderFns } from "./QcChain.vue?vue&type=template&id=75640207&scoped=true"
import script from "./QcChain.vue?vue&type=script&lang=js"
export * from "./QcChain.vue?vue&type=script&lang=js"
import style0 from "./QcChain.vue?vue&type=style&index=0&id=75640207&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75640207",
  null
  
)

export default component.exports